/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityDto } from '../../models/amoxcalli-activity-dto';

export interface ApiActivitiesIdGet$Plain$Params {
  id: string;
}

export function apiActivitiesIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiActivitiesIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliActivityDto>> {
  const rb = new RequestBuilder(rootUrl, apiActivitiesIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliActivityDto>;
    })
  );
}

apiActivitiesIdGet$Plain.PATH = '/api/activities/{id}';
